import { useState } from 'react'

export default function useStateUpdate(setStake: any) {
  const [autoRollNumber, setautoRollNumber] = useState<string>('')
  const [autoMaxStake, setautoMaxStake] = useState<string>('')
  const [stopOnProfit, setstopOnProfit] = useState<string>('')
  const [stopOnLoss, setstopOnLoss] = useState<string>('')
  const [onWinPercent, setonWinPercent] = useState<string>('')
  const [onLossPercent, setonLossPercent] = useState<string>('')
  // const [onWin, setonWin] = useState<boolean>(true)
  // const [onLoss, setonLoss] = useState<boolean>(true)

  const handleStateUpdate = (s: string, name: string) => {
    switch (name) {
      case 'ROLL_NUMBER':
        setautoRollNumber(s)
        break
      case 'MAX_STAKE':
        setautoMaxStake(s)
        break
      case 'STOP_ON_PROFIT':
        setstopOnProfit(s)
        break
      case 'STOP_ON_LOSS':
        setstopOnLoss(s)
        break
      case 'ON_WIN_PERCENT':
        setonWinPercent(s)
        break
      case 'ON_LOSS_PERCENT':
        setonLossPercent(s)
        break
      case 'STAKE':
        setStake(s)
        break
      default:
        break
    }
  }
  return {
    autoRollNumber,
    autoMaxStake,
    stopOnProfit,
    stopOnLoss,
    onWinPercent,
    onLossPercent,
    // onWin,
    // onLoss,
    handleStateUpdate,
  }
}
